export enum ThemesColour {
  BRAND = 'brand',
  SEASONAL = 'seasonal',
}
